import { c as _c } from "react/compiler-runtime";
import CarouselComponent, { CarouselType } from '@spa/components/carousel/carousel.component';
import { ReactElement, memo } from 'react';
import { BazaarvoiceReviewPhoto } from './bazaarvoice-review-photo';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ProductReviewPhoto } from '@spa/generated/graphql/graphql';
import { createReviewPhotoDescriptionFactory } from './review-photo-description-factory';
import styles from './bazaarvoice-review-photos-gallery.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly id: string;
  readonly photos: readonly ProductReviewPhoto[];
}
function BazaarvoiceReviewPhotosGallery(t0) {
  const $ = _c(22);
  const {
    id,
    photos
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== formatMessage || $[1] !== id || $[2] !== photos) {
    const reviewPhotoDescriptionFactory = createReviewPhotoDescriptionFactory({
      formatMessage
    });
    t4 = styles["bazaarvoice-review-photos-gallery"];
    let t6;
    if ($[9] !== formatMessage) {
      t6 = formatMessage("customerPhotosHeadline");
      $[9] = formatMessage;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    if ($[11] !== t6) {
      t5 = <h3 className="bold">{t6}</h3>;
      $[11] = t6;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    T0 = CarouselComponent;
    t1 = `${id}-photos-carousel`;
    t2 = CarouselType.MEDIA;
    t3 = photos.map((photo, index) => <BazaarvoiceReviewPhoto key={photo.id} photo={photo} description={reviewPhotoDescriptionFactory.getReviewPhotoDescription(photo, index, photos.length)} />);
    $[0] = formatMessage;
    $[1] = id;
    $[2] = photos;
    $[3] = T0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    T0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[13] !== T0 || $[14] !== t1 || $[15] !== t2 || $[16] !== t3) {
    t6 = <T0 id={t1} carouselType={t2}>{t3}</T0>;
    $[13] = T0;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
export default memo(BazaarvoiceReviewPhotosGallery);